// extracted by mini-css-extract-plugin
export default {"container":"clUwGgvBk","message":"cFr7LVVdi"};